import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import store from '@/redux/store';
import {history} from "@/redux/store";
import {  push } from 'react-router-redux'
import CookieHelper from "helpers/cookie";
import { EyeIcon } from '@heroicons/react/24/outline';
import Drawer from "@/controllers/Drawer";
import {removeUser} from "@/reducers/User";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";
import { DrawerDetail } from "./drawer/DrawerDetail";

export function AdminUserOverview({...props}) {
    const [selectedData, setSelectedData] = useState(null);
         const navigate = useNavigate();
function test(event) {
        event.stopPropagation();
        event.preventDefault();
        
                var date = new Date();
            date.setTime(date.getTime()+(-12*60*60*1000));
            CookieHelper.setCookie("ppc_obj", "", date.getTime()/ 1000 );

    
    navigate("/login");
    //store.dispatch(push('/customers/', {test:1}));
    //window.location.pathname = '/customers/';
    return false;    
    }

    const setSelected = (idx) => {
      console.debug(idx, props?.users);
      let item = props?.users[idx];
      setSelectedData({data: item, idx: parseInt(idx),  uuid: uuid().slice(0, 8)});
      console.debug(selectedData, idx);

    }

const showPreview =(event, item, idx) => {
    event.preventDefault();
    
    setSelectedData({data: item, idx: parseInt(idx), uuid: uuid().slice(0, 8)});
    return false;
  }

      const onkeypressTest=((e) => {
        let curIdx = (selectedData?.idx ? selectedData?.idx : 0);
        if(e.key === 'ArrowRight') {
          let newIdx = parseInt(curIdx)+1;
          console.debug(parseInt(curIdx), newIdx);
          console.debug(parseInt(props?.users.length), props?.users);
          if(props?.users.length <= newIdx) {
            newIdx = 0;
          }
          setSelected(newIdx);
        } else if(e.key === 'ArrowLeft') {
          let newIdx = parseInt(curIdx) -1;
          if(newIdx < 0) {
            newIdx = (props?.users.length - 1 );
          }
          setSelected(newIdx);
        }


        console.log(e);
        return false;
      }).bind(this);
  
  React.useEffect(() => {
  
    console.clear();
    console.debug("LOAD OVER VIEW");
    window. addEventListener("keydown", onkeypressTest);
    return () => {
      console.debug("UNLOAD !!!");  
      window.removeEventListener("keydown", onkeypressTest);
    }
      
      
  });
  
  console.debug("HI ID ",selectedData);
  return (
    <>

    <div className="">
    
<div className="pb-5 sm:flex sm:items-center sm:justify-between">
        <div className="sm:w-0 sm:flex-1">
      <h3 className="text-base font-semibold leading-6 text-gray-900">Alle gebruikers</h3>
<p className="mt-2 max-w-4xl text-sm text-gray-500">
        In onderstaand overzicht worden alle gebruikers welke gebruik maken van het paperchip systeem weergegeven.
        
      </p>      
        </div>      
      
    </div>    
    
    
      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Naam
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Email
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" key={uuid().slice(0, 8)}>
                {props?.users && props.users.map((item, i) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        <div className="flex gap-x-6">
                            <EyeIcon className="hidden h-6 w-5 flex-none text-gray-400 sm:block cursor-pointer" onClick={(e) => {showPreview(e, item, i);}}/>

                      {item.fullName}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.email}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ ((item?.userfields?.userobj) ?  (item?.userfields?.userobj)?.company_email : "") }</td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                      <Link to={"edit/"+item.key} className="text-indigo-600 hover:text-indigo-900">
                        Edit<span className="sr-only">, {item.name}</span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
    </div>

          <Drawer data={selectedData} type="user" key={ (selectedData?.uuid ? selectedData?.uuid : uuid().slice(0, 8)) }>
                <DrawerDetail data={selectedData} />
          </Drawer>

    </>
      );
}
